import { API_CONFIG } from '../config/api';

export interface MaintenanceStatus {
  isActive: boolean;
  message: string | null;
  estimatedEnd: string | null;
  updatedAt: string;
}

class MaintenanceService {
  async getStatus(): Promise<MaintenanceStatus> {
    const response = await fetch(`${API_CONFIG.BASE_URL}/maintenance`, {
      headers: { 'Accept': 'application/json' },
    });
    if (!response.ok) throw new Error('Failed to fetch maintenance status');
    const json = await response.json();
    // Handle both direct and wrapped response format
    return json.data ?? json;
  }
}

export const maintenanceService = new MaintenanceService();
